import { IgAgeRateDetails_ageGroup } from './__generated__/IgAgeRateDetails';

export const getAgeGroups = (ageGroup: IgAgeRateDetails_ageGroup[] | null) =>
  ageGroup ? ageGroup.map(item => (item.start === 65 ? '65+' : `${item.start}-${item.end}`)) : [];
